// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__2Uqzn","grid_item":"style_grid_item__eU1Xj","item__icon":"style_item__icon__3eep3","item__title":"style_item__title__D8Vzd"};